Namespace 'Monitoring.Reports.Campaign'

class Monitoring.Reports.Campaign.PostView extends Backbone.View
  template: JST['backbone/templates/monitoring/reports/campaign/post']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    @$el.html(@template({network: @options.title}))
    sections = @customSections()
     
    sections = sections.concat([
      new Monitoring.Reports.Campaign.PostSocialView(@options),
      new Monitoring.Reports.Campaign.SentimentByTagView($.extend({}, @options, {posts: [@options.post], chart: 'column'})),
      new Monitoring.Reports.Campaign.SentimentDistributionView($.extend({}, @options, {posts: [@options.post], chartTitle: 'Sentiment'})),
      new Monitoring.Reports.Campaign.PositiveVsNegativeView($.extend({}, @options, {posts: [@options.post]})),
      new Monitoring.Reports.Campaign.TagsView($.extend({}, @options, {posts: [@options.post], chart: 'column', contentsByTag: true})),
      new Monitoring.Reports.Campaign.PostClassifiedView($.extend({}, @options, {contentsByTag: true})),
      new Monitoring.Reports.Campaign.TagsView($.extend({}, @options, {posts: [@options.post], chart: 'column'})),
      new Monitoring.Reports.Campaign.PostClassifiedView(@options)
      ]
    )

    @pending = sections.length
    @renderPreview()

    for section in sections
      section.bind('rendered', @_sectionRendered)
      section.render()
      @$('[data-view=' + section.className + ']').append(section.el)

  _sectionRendered: =>
    @pending -= 1
    @trigger('rendered') if @pending == 0

  customSections: =>
    sections = [
      new Monitoring.Reports.Campaign.PostInsightsView(@options)
    ]

  renderPreview: =>
    @$('[data-view=post-preview]').append(@preview(@options.post))
